import { Enums } from "../common/enums"

import { ICopyable, IOpChangeState } from "../util/interfaces"
import { OpDescr } from "../core"
import { OpTransmissionDriver } from "./op-transmission-driver"

export class OpPacketStatus implements IOpChangeState, ICopyable<OpPacketStatus> {

    //#region Properties

    public idPacketStatus: Enums.PacketStatus
    public name: string
    public idDescr: number

    //#endregion


    //#region Navigation properties

    public transmissionDriver: OpTransmissionDriver
    public descr: OpDescr

    //#endregion


    //#region Custom properties

    public opState: Enums.OpChangeState

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    public toString(): string {
        if (this.descr != null) {
            return this.descr.toString()
        } else {
            return this.name
        }
    }


    //#region IJsonSerializer Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj != null) {
            this.idPacketStatus = opObj.ID_PACKET_STATUS
            this.name = opObj.NAME
            this.idDescr = opObj.ID_DESCR
            this.opState = opObj.OpState

            if (opObj.Descr != null) {
                this.descr = new OpDescr(opObj.Descr)
            }

            if (opObj._TransmissionDriver != null) {
                this.transmissionDriver = new OpTransmissionDriver(opObj._TransmissionDriver)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            ID_PACKET_STATUS: this.idPacketStatus,
            NAME: this.name,
            ID_DESCR: this.idDescr,
            OpState: this.opState,

            Descr: this.descr != null ? this.descr.toJSON() : null,
            _TransmissionDriver: this.transmissionDriver != null ? this.transmissionDriver.toJSON() : null
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpPacketStatus {
        const status: OpPacketStatus = new OpPacketStatus(null)

        status.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return status
    }

    public copy(source: OpPacketStatus, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return
        }

        if (includeNavigationProperties) {
            if (source.transmissionDriver != null) {
                const driver: OpTransmissionDriver = new OpTransmissionDriver(null)
                driver.copy(source.transmissionDriver, true, true, true, true)
                this.transmissionDriver = driver
            }

            if (source.descr != null) {
                const descr: OpDescr = new OpDescr(null)
                this.descr = OpDescr.restore(source.descr)
            }
        }

        if (includeCustomProperties) {

        }

        if (includeDataList) {
            //no dataList
        }

        if (includeDynamicValues) {
            //no dynamic values
        }

        this.idPacketStatus = source.idPacketStatus
        this.name = source.name
        this.idDescr = source.idDescr

        this.opState = source.opState
    }

    //#endregion


}